export function DownloadImageIcon({ color }: { color: string }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.17578 3C8.34607 2.2793 8.63643 1.60573 9.02441 1H3C2.20435 1 1.44152 1.3163 0.878906 1.87891C0.316297 2.44152 0 3.20435 0 4V16C0 16.7957 0.316297 17.5585 0.878906 18.1211C1.44152 18.6837 2.20435 19 3 19H15C15.7957 19 16.5585 18.6837 17.1211 18.1211C17.6837 17.5585 18 16.7957 18 16V9.97461C17.3942 10.3627 16.7204 10.6534 16 10.824V15.5859L9.12109 8.70703C8.55851 8.14462 7.79549 7.82812 7 7.82812C6.20451 7.82812 5.44149 8.14462 4.87891 8.70703L2 11.5859V4C2 3.73478 2.10543 3.4805 2.29297 3.29297C2.4805 3.10543 2.73478 3 3 3H8.17578ZM14.5859 17H3C2.73478 17 2.48051 16.8946 2.29297 16.707C2.10543 16.5195 2 16.2652 2 16V14.4141L6.29297 10.1211C6.48049 9.93369 6.73489 9.82812 7 9.82812C7.26509 9.82812 7.51952 9.93372 7.70703 10.1211L14.5859 17Z"
        fill={color}
      />
      <path
        d="M14.4996 0C15.0517 0.000227481 15.4996 0.447856 15.4996 1V5.82617L17.3492 4.24121C17.7685 3.88202 18.399 3.93036 18.7584 4.34961C19.1175 4.76885 19.069 5.39939 18.65 5.75879L15.15 8.75879C14.7756 9.07971 14.2237 9.07957 13.8492 8.75879L10.3492 5.75879C9.92986 5.39937 9.88137 4.76894 10.2408 4.34961C10.6002 3.93048 11.2307 3.88185 11.65 4.24121L13.4996 5.82617V1C13.4996 0.447715 13.9473 2.41411e-08 14.4996 0Z"
        fill={color}
      />
    </svg>
  );
}
